import { Injectable } from "@angular/core";
import {
    HttpClient,
    HttpHeaders,
    JsonpClientBackend,
} from "@angular/common/http";
import { environment } from "src/environments/environment";
import { map } from "rxjs/operators";
import { Subject, Observable } from "rxjs";
//import { NodoArbolMenu } from "src/app/asistente-en-linea/components/asistencia-menu-arbol/models/nodo-arbol-menu";
import { EditingMode } from "../../models/editingMode";
import { AuthService } from '../../auth/auth.service';
import { Role } from '../../models/role';
import { AreaFuncionalGAFU } from '../../models/area-funcional-gafu';

const endpoint = environment.apiBaseUrl + '/admin/menu';
const endpointAsistentes = environment.apiBaseUrl + '/admin/asistente';

const httpOptions = {
    headers: new HttpHeaders({
        'Accept': 'application/json',
        'Content-Type': 'application/octet-stream'
    }),
};

@Injectable({
    providedIn: "root",
})
export class MenuService {

    constructor(private httpClient: HttpClient, private authService: AuthService) {

    }

    private extractData(res: Response) {
        const body = res;
        return body || {};
    }

    esAdministrador() {
        for (let role of this.authService.getUser().roles) {
            if (role == Role.Admin || role == Role.MenuAdministrator) {
                return true;
            }
        }
        return false;
    }
    //HTTP
    //Cargar el árbol y las preguntas frecuentes con sus ids.
    loadAsistentes() {
        let areasFuncionales = [];
        let params;
        //console.log("areas funcionales:",this.authService.getUser().areasFuncionales);
        if (this.esAdministrador()) {
            areasFuncionales.push(new AreaFuncionalGAFU(null, "ALL", null));
            params = {
                areasFuncionalesGafu: areasFuncionales
            }
        } else {
            const areas: string[] = (this.authService.getUser().areasFuncionales || []).map(a => String(a));

            for (let area of areas) {
                const areaTmp = new AreaFuncionalGAFU("", area, "");
                //console.log(areaTmp);
                areasFuncionales.push(areaTmp);
            }
            //areasFuncionales = this.authService.getUser()?.areasFuncionales || [];
            params = {
                areasFuncionalesGafu: areasFuncionales
            }
        }

        return this.httpClient.post<any>(endpointAsistentes + `/list`, params).pipe(map(this.extractData));
    }

    // loadMenuByID(idMenu) {
    //     return this.httpClient. get<any>(endpoint + `/display/${idMenu}`).pipe(map(this.extractData));
    // }

    // loadMenuByID(idMenu) {
    //     return this.httpClient.get<any>(endpoint + `/${idMenu}`).pipe(map(this.extractData));
    // }

    salirAdministrador() {
        this.authService.logout();
    }

    // agregarMenu(codigoAsistente, descripcion, texto, gafuAreaFuncional, updateUser) {
    //     const params = {
    //         codigoAsistente: codigoAsistente,
    //         descripcion: descripcion,
    //         texto: texto,
    //         gafuAreaFuncional: gafuAreaFuncional,
    //         userName: updateUser
    //     }
    //     return this.httpClient.post(`${endpoint}/add`, params)
    // }

    // actualizarMenu(idMenuBD, idMenu, descripcion, texto, gafuAreaFuncional, updateUser, habilitado) {
    //     const params = {
    //         idAsistente: idMenu,
    //         idMenuBD: idMenuBD,
    //         descripcion: descripcion,
    //         texto: texto,
    //         gafuAreaFuncional: gafuAreaFuncional,
    //         userName: updateUser,
    //         habilitado: habilitado
    //     }
    //     return this.httpClient.post(`${endpoint}/update`, params)
    // }

    exportarMenu(idMenu): Observable<Blob> {
        return this.httpClient.get(`${endpoint}/exportar/${idMenu}`, { responseType: 'blob' })
    }

    importarMenu(data, idMenu, updateUser) {
        return this.httpClient.post(`${endpoint}/importar/${idMenu}/${updateUser}`, data);
    }

    importarDestinatariosAsistentes(data: FormData, updateUser: string) {
        return this.httpClient.post(`${endpoint}/importarDestinatariosAsistentes/${updateUser}`, data);
    }

    exportarDestinatariosAsistentes(id: object, request: any) {
        return this.httpClient.post<Blob>( `${endpoint}/exportarDestinatariosAsistentes/${id}`, request, { responseType: 'blob' as 'json' }  );
    }

    deleteMenu(id, updateUser) {
        const params = {
            id
        }
        return this.httpClient.post(`${endpoint}/delete/${id}/${updateUser}`, params);
    }

    //Cargar el árbol y las preguntas frecuentes con sus ids.
    loadDestinatariosMenu(idMenu, soloHabilitado) {
        const params = {
            idAsistenteMenu: idMenu,
            soloHabilitado: soloHabilitado
        }
        return this.httpClient.post<any>(endpoint + `/destinatarios/list`, params).pipe(map(this.extractData));
    }

    loadValidacionesMenu(idMenu, soloHabilitado) {
        const params = {
            idAsistenteMenu: idMenu,
            soloHabilitado: soloHabilitado
        }
        return this.httpClient.post<any>(endpoint + `/validaciones/list`, params).pipe(map(this.extractData));
    }

    guardarDestinatariosMenu(idMenu, updateUser, destinatarios) {
        const params = {
            idAsistenteMenu: parseInt(idMenu),
            userName: updateUser,
            destinatarios: destinatarios
        }
        return this.httpClient.post(`${endpoint}/destinatarios/add`, params)
    }

    guardarValidacionesMenu(idMenu, updateUser, validaciones) {
        const params = {
            idAsistente: parseInt(idMenu),
            userName: updateUser,
            listaValidaciones: validaciones
        }
        return this.httpClient.post(`${endpoint}/validaciones/add`, params)
    }
}

